import { useTermoNotificacao } from "@/contexts/fiscalizacao/termoNotificacao/hooks/useTermoNotificacao";
import { formatMessageError } from "@/shared/utils/formatMessageError";
import { App, Form, Input, Modal } from "antd";
import { useState } from "react";

interface FormValues {
  motivoCancelamento: string;
}

export function ModalCancelarTermoNotificacao({
  isOpen,
  onClose,
  termoNotificacaoId,
  reloadItems,
}: {
  isOpen: boolean;
  onClose: () => void;
  termoNotificacaoId: number;
  reloadItems: () => void;
}) {
  const [form] = Form.useForm<FormValues>();
  const { message, notification } = App.useApp();
  const {
    cancelarTermoNotificacaoApi,
    listaTermosNotificacao,
    removeTermoNotificacao,
  } = useTermoNotificacao();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async ({ motivoCancelamento }: FormValues) => {
    try {
      setIsLoading(true);
      message.loading({
        content: "Cancelando Termo de Notificação...",
        key: "loading",
        duration: 0,
      });
      await cancelarTermoNotificacaoApi(termoNotificacaoId, motivoCancelamento);

      message.destroy("loading");
      setIsLoading(false);

      const termoNotificacaoOffline = listaTermosNotificacao.find(
        (r) => r.id === termoNotificacaoId
      );

      if (termoNotificacaoOffline) {
        removeTermoNotificacao(termoNotificacaoOffline.offlineId!);
      }

      notification.success({
        message: "Termo de Notificação cancelado com sucesso!",
      });

      reloadItems();

      form.resetFields();
      onClose();
    } catch (error) {
      console.error("Erro ao cancelar o termo de notificação:", error);
      message.destroy("loading");
      setIsLoading(false);
      const messageError = formatMessageError(error);
      notification.error({
        message: "Não foi possível cancelar o termo de notificação",
        description: messageError,
      });
      return;
    }
  };

  return (
    <Modal
      title="Cancelar Termo de Notificação"
      open={isOpen}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      okButtonProps={{
        form: "form-cancelar-termo-notificacao",
        htmlType: "submit",
        danger: true,
        ghost: true,
        loading: isLoading,
        disabled: isLoading,
      }}
      cancelButtonProps={{
        disabled: isLoading,
      }}
      okText="Confirmar"
      cancelText="Fechar"
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleSubmit}
        id="form-cancelar-termo-notificacao"
      >
        <Form.Item
          label="Descreva o motivo para o cancelamento do termo de notificação"
          name="motivoCancelamento"
          rules={[{ required: true }]}
        >
          <Input.TextArea
            rows={4}
            placeholder="Informe o motivo do cancelamento"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
